import React, { Component } from 'react';

// React Final Form
import Button from '@material-ui/core/Button';

// React-PDF dependencies
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer'

// Graphql
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

// Material UI Imports
import { FormControl, FormLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import { DatePicker } from 'material-ui-pickers';
import IconBack from '@material-ui/icons/ArrowBack';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InfoIcon from '@material-ui/icons/Info';

// Assets imports
import '../styles/ProjectPrint.css';

// Components Imports
import ProjectPdf from './ProjectPdf';

// Import Loader Component
import CustomLoader from './innerComponents/CustomLoader';

import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';

// axios
import axios from "axios";

const paperStyle = {
  // General styles for paper
  width: "60%",
  margin: "0 auto",
  height: "auto",
  marginBottom: 30,
};

const alertStyle = {
  color: "#fff",
  fontWeight: 500,
  backgroundColor: "#015597",
  display: "flex",
  padding: "6px 16px",
  borderRadius: "4px",
  fontSize: "0.875rem",
  opacity: "0.8"
}

const alertIcon = {
  display: "flex",
  opacity: "0.9",
  padding: "7px 0",
  fontSize: "22px",
  marginRight: "12px",  
}

const alertMessage = {
  padding: "8px 0"
}

const styles = theme => ({

});

class ProjectPrint extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sections : {
        showBasicInfoSection: true,
        showProjectLogSection: true,
        showPRCSection: true,
        showSmokeTestSection: true,
      },
      date : {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1),
        endDate: new Date(),
        activeFilter: true,
      },
      data : {
        images: [],
        imagesLoaded: false,
      },
      selectedProjectId: props.match.params.id,
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(
    //   () => this._isTheImagesLoaded(),
    //   3000
    // );
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  _activateLoadingSpinner = () => {
    this.setState(state => ({
      data: {
        ...this.state.data,
        imagesLoaded: false,
      }
    }));;
  }

  _toggleSection = (sectionName) => {
    // this._activateLoadingSpinner();
    this.setState(state => ({
      sections: {
        ...this.state.sections,
        [sectionName]: !this.state.sections[sectionName],
      }
    }));
  }

  _handleDateChange = (dateLabel, date) => {
    // this._activateLoadingSpinner();
    this.setState(state => ({
      date: {
        ...this.state.date,
        [dateLabel]: date,
      }
    }));
  }

  _activateDateFilter = (dateLabel) => {
    // this._activateLoadingSpinner();
    this.setState(state => ({
      date: {
        ...this.state.date,
        [dateLabel]: !this.state.date[dateLabel],
      }
    }));
  }

  _isTheImagesLoaded = () => {

    let successfullyLoadedImages = 0;
    this.state.data.images.forEach((element) => {
      if(element.loaded)
        successfullyLoadedImages++
    });
    if(this.state.data.images.length === 0  || (this.state.data.images.length > 0 && successfullyLoadedImages === this.state.data.images.length)) {
      this.setState(state => ({
        data: {
          ...this.state.data,
          imagesLoaded: true,
        }
      }));
    }

  }

  onGeneratePdfClick = () => {
    var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + "/reports/generate_project_pdf_report";

    axios.post(
        apiBaseUrl,
        {
          project_id:  parseInt(this.state.selectedProjectId),
          sections: this.state.sections,
          date: this.state.date
        },
        {headers: {'Authorization': localStorage.getItem("token")}}
    ).then((response)=>{
        if (response.data.msg && response.data.msg === 'generating') {
          this.setState({showLink: true});
          setTimeout(() => {
            this.setState({showLink: false});
          }, 5000);
        }
    }).catch((error) => {
        alert('Project Pdf Report could not be generated');
    });
  }

  render() {

    // // Check if the query response is being loaded
    // if (this.props.data && this.props.data.loading) {
    //   return <CustomLoader label={'Loading'}/>
    // }

    // // Check if there were errors
    // if (this.props.data && this.props.data.error) {
    //   console.log(this.props.data.error)
    //   return <div>Error</div>
    // }

    // Get the data to render it
    // const current_project = this.props.data.project;

    return (
      <div className="ProjectPrint">
        <div className="ProjectPrint-pdfTitle">
          Project Pdf Report
        </div>
        <Paper style={paperStyle} elevation={1}>
          <div className="FilterSection">
            <FormLabel component="legend">Section filters</FormLabel>
            <div>
              <FormControl component="fieldset">
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sections['showBasicInfoSection']}
                        onChange={() => this._toggleSection('showBasicInfoSection')}
                        value="showBasicInfoSection"
                        color="primary"
                      />
                    }
                    label = 'General Information'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sections['showProjectLogSection']}
                        onChange={() => this._toggleSection('showProjectLogSection')}
                        value="showProjectLogSection"
                        color="primary"
                      />
                    }
                    label = 'Project Log'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sections['showPRCSection']}
                        onChange={() => this._toggleSection('showPRCSection')}
                        value="showPRCSection"
                        color="primary"
                      />
                    }
                    label = 'Post Remediation Checklist'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sections['showSmokeTestSection']}
                        onChange={() => this._toggleSection('showSmokeTestSection')}
                        value="showSmokeTestSection"
                        color="primary"
                      />
                    }
                    label = 'Show Smoke Test Section'
                  />
                </FormGroup>
              </FormControl>
            </div>
          </div>
        </Paper>
        <Paper style={paperStyle} elevation={1}>
          <div className="FilterSection">
            <FormLabel component="legend">Project log date filter</FormLabel>
            <div className="DateFilterSection">

              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.date['activeFilter']}
                    onChange={() => this._activateDateFilter('activeFilter')}
                    value="activeDateFilter"
                    color="primary"
                  />
                }
                label = 'Active date filter'
              />

              <FormGroup row>
                <DatePicker
                  disableOpenOnEnter
                  format="YYYY-MM-DD"
                  value={this.state.date.startDate}
                  onChange={(date) => this._handleDateChange('startDate', date)}
                  label="Start Date"
                />
                <DatePicker
                  disableOpenOnEnter
                  format="YYYY-MM-DD"
                  value={this.state.date.endDate}
                  onChange={(date) => this._handleDateChange('endDate', date)}
                  minDate={this.state.date.startDate}
                  label="End Date"
                  minDateMessage='Date should not be before start date'
                />
              </FormGroup>
            </div>
          </div>
        </Paper>
        <Paper style={paperStyle} elevation={1}>
          <div className="ProjectPrint-detailFooter">
            <Button variant="contained"
              color="primary"
              onClick={this.props.history.goBack}
            ><IconBack style={{marginRight:8}}/> Back</Button>
            <Button variant="contained" color="primary" onClick={() => this.onGeneratePdfClick()}>
              <PictureAsPdfIcon style={{ marginRight: 8 }} /> Generate Pdf
            </Button>
          </div>
        </Paper>

        { this.state.showLink &&
          <Paper style={paperStyle} elevation={1}>
            <div style={alertStyle}>
              <div style={alertIcon}>
                <InfoIcon />
              </div>
              <div style={alertMessage}>
                Project report is being generated through Pdf Task. Please check Pdf Operations List or click
                {' '}
                <strong><a href="/project/list" style={{color: "#f3d9b1"}}>here</a></strong>
              </div>              
            </div>
          </Paper>
        }        
      </div>
    );
  }
}

const PROJECTS_QUERY = gql`
  query project_query($selectedId: ID!){
    project(id: $selectedId) {
      id
      endDate
  		startDate
  		siteAddress
  		siteName
  		location
  		name
  		number
      creator{
        id
        fullName
      }
      insertedAt
      region{
        id
        name
      }

      supervisors{
        id
        name
        fullName
        role
        email
        active
      }

      projectInvitations(filters:[{field:"mark_as_deleted_eq",operand:"false"}]){
          id
      markAsDeleted
      user{
        id
        fullName
      role
      email
      active
      }
      }

      enclosures{
        id
        name
      }

      projectLogEntries{
        comment
        inserted_at
        date
        device{
          user{
            fullName
          }
        }
        images{
          id
          project{
            id
          }
          baseFileName
        }
      }

      postRemediationChecklists{
        id
        date
        enclosure {
          id
          name
        }
        questionGroup{
          section
          device{
            id
            type
            user{
              id
              fullName
              name
            }
          }

          questions{
            statement
            position
            comment
            id
            images{
              id
              description
              project{
                id
              }
            }
            answer
            type
          }
        }
      }

      smokeTests{
        nameOfWitness
        date
        time
        enclosure{
          id
          name
        }
        company
        id
      }


      dailyEntries{
        date
        id
        device{
          user{
            name
            fullName
            role
            active
          }
        }
        operatives{
          id
          name
          fullName
          active
        }

        negativePressureUnitChecks{
          id
          amReading
          pmReading
          negativePressureUnit{
            id
            serial
            nextRetestDate
          }
        }

        questionGroups{
          section
          device{
            id
            type
            user{
              id
              name
              active
            }
          }

          questions{
            statement
            position
            comment
            id
            images{
              id
              description
            }
            answer
            type
          }
        }
      }
    }
  }
`;

export default (withStyles(styles)(ProjectPrint));

// export default graphql(PROJECTS_QUERY, {
//   options: (props) => ({ variables: { selectedId: props.match.params.id } })
// })(withStyles(styles)(ProjectPrint));


// WEBPACK FOOTER //
// src/components/ProjectPrint.js